import { ServiceName, ServicePermissionName } from '@consigli/types';
import { TFunction } from 'i18next';

export const translateServiceTypes = (t: TFunction<'translation', undefined>) => [
  {
    label: t('services.management-operations-maintenance'),
    value: ServicePermissionName.USE_MANAGE_OPERATE_SERVICE,
  },
  {
    label: t('services.offer'),
    value: ServicePermissionName.USE_OFFER_SERVICE,
  },
  {
    label: t('services.tender-documents'),
    value: ServicePermissionName.USE_TENDER_DOCUMENTS_SERVICE,
  },
  {
    label: t('services.rfp-rfq-review'),
    value: ServicePermissionName.USE_RFP_RFQ_REVIEW_SERVICE,
  },
  {
    label: t('services.due-diligence'),
    value: ServicePermissionName.USE_DUE_DILIGENCE_SERVICE,
  },
  {
    label: t('services.site-due-diligence'),
    value: ServicePermissionName.USE_SITE_DUE_DILIGENCE_SERVICE,
  },
  {
    label: t('services.tenant-requirements'),
    value: ServicePermissionName.USE_TENANT_REQ_SERVICE,
  },
  // {
  //   label: t('services.tenant-specification'),
  //   value: ServicePermissionName.USE_TENANT_SPEC_SERVICE,
  // },
  {
    label: t('services.floor-plan'),
    value: ServicePermissionName.USE_FLOOR_PLAN_SERVICE,
  },
  {
    label: t('services.ceiling-plan'),
    value: ServicePermissionName.USE_CEILING_PLAN_SERVICE,
  },
  {
    label: t('services.plant-room'),
    value: ServicePermissionName.USE_PLANT_ROOM_SERVICE,
  },
  {
    label: t('services.space-analysis'),
    value: ServicePermissionName.USE_SPACE_ANALYSIS_SERVICE,
  },
  // {
  //   label: t('services.structural'),
  //   value: ServicePermissionName.USE_STRUCTURAL_SERVICE,
  // },
  {
    label: t('services.parking'),
    value: ServicePermissionName.USE_PARKING_SERVICE,
  },
  {
    label: t('services.reports'),
    value: ServicePermissionName.USE_REPORTS_SERVICE,
  },
  {
    label: t('services.load-calculation'),
    value: ServicePermissionName.USE_LOAD_CALCULATION_SERVICE,
  },
  {
    label: t('services.schedule-check'),
    value: ServicePermissionName.USE_SCHEDULE_CHECK_SERVICE,
  },
  {
    label: t('services.solution-viewer'),
    value: ServicePermissionName.USE_SOLUTION_VIEWER_SERVICE,
  },
  {
    label: t('services.meeting-secretary'),
    value: ServicePermissionName.USE_MEETING_SECRETARY_SERVICE,
  },
  {
    label: t('services.report-generation'),
    value: ServicePermissionName.USE_REPORT_GENERATION_SERVICE,
  },
  {
    label: t('services.contract-review'),
    value: ServicePermissionName.USE_CONTRACT_REVIEW_SERVICE,
  },
  {
    label: t('services.luminaire-schedule'),
    value: ServicePermissionName.USE_LUMINAIRE_SCHEDULE_SERVICE,
  },
  {
    label: t('services.design-package-review'),
    value: ServicePermissionName.USE_DESIGN_PACKAGE_REVIEW_SERVICE,
  },
  {
    label: t('services.qa-agent'),
    value: ServicePermissionName.USE_QA_AGENT_SERVICE,
  },
  {
    label: t('services.code-research-agent'),
    value: ServicePermissionName.USE_CODE_RESEARCH_AGENT_SERVICE,
  },
  {
    label: t('services.geotechnical-extraction-agent'),
    value: ServicePermissionName.USE_GEOTECHNICAL_EXTRACTION_AGENT_SERVICE,
  },
  {
    label: t('services.environment-report-agent'),
    value: ServicePermissionName.USE_ENVIRONMENT_REPORT_AGENT_SERVICE,
  },
  {
    label: t('services.lightning-designer'),
    value: ServicePermissionName.USE_LIGHTNING_DESIGNER_SERVICE,
  },
];

export const compareWithTenantServiceTypes = (t: TFunction<'translation', undefined>) => [
  {
    label: t('services.tender-documents'),
    value: ServiceName.TENDER_DOCUMENTS,
  },
];

export const compareWithOfferServiceTypes = (t: TFunction<'translation', undefined>) => [
  {
    label: t('services.tender-documents'),
    value: ServiceName.TENDER_DOCUMENTS,
  },
];
